export const formDefaultValues = {
  name: '',
  price: '',
  description: '',
}
